<script>
export default {
  name: 'ReminderListsTabs',
  data() {
    return {
      activeTab: undefined,
      tabs: [
        { name: 'Info', route: 'ReminderLists' },
        { name: 'Overdue Without Reminders', route: 'ReminderListsOverdue' },
        { name: 'Last Reminder', route: 'ReminderListsLastReminder' },
        { name: 'Archived', route: 'ReminderListsArchived' },
      ],
    };
  },
};
</script>

<template>
  <v-tabs v-model="activeTab" mandatory>
    <v-tab
      v-for="tab in tabs"
      v-bind="tab"
      :key="tab.route"
      :to="{ name: tab.route }"
      exact
    >
      {{ tab.name }}
    </v-tab>
  </v-tabs>
</template>



// WEBPACK FOOTER //
// src/components/Reminders/ReminderListsTabs.vue